<template>
  <div>
    <v-row class="mx-auto px-0 py-0" style="background-color:#f5f5f5">
      <v-col cols="12" class="px-0 pb-0 pt-2">

        <v-card tile>
          <v-card-title style="color:#12253a;">

            <span class="d-flex align-center">
              <span>
                <v-avatar :color="govColor(entity.gov_type)" size="36" class="mr-3 pl-0 ml-0">
                  <span class="white--text caption">{{ entity.gov_type }}</span>
                </v-avatar>
              </span>
              <div>
                <v-card-subtitle color="secondary" class="pa-0 font-weight-light">Public Entity</v-card-subtitle>
                <span>{{ entity.name }}</span>
              </div>
            </span>
            <div class="flex-grow-1 desktop-nav"></div>

            <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" large icon color="primary" light style="text-decoration: none !important;"
                    @click="openInsightsModal">
                    <v-icon>mdi-lightbulb-on</v-icon>
                  </v-btn>
                </template>
                <span>View Strategic Analysis</span>
              </v-tooltip>
            </span>

            <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <cluster-select :large="false"
                      @clearSelections="selected = [], selectAll = false, selectedEntities = []" :disabled="notSelected"
                      :entityType="'publisher'" :entityIDType="'publisher_id'" :entities="selected"
                      :entity-labels="entity.id ? { [entity.id]: entity.name } : {}" />
                  </span>
                </template>
                <span>Add {{ entity.name }} to a cluster</span>
              </v-tooltip>
            </span>

            <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" large icon color="#4EB888" light style="text-decoration: none !important;"
                    :to="{ name: 'search', query: { publisher_id: entity.id } }">
                    <v-icon>mdi-format-list-bulleted</v-icon>
                  </v-btn>
                </template>
                <span>View all {{ entity.name }} notices</span>
              </v-tooltip>
            </span>
            <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" large icon color="secondary" light style="text-decoration: none !important;"
                    target="_blank" :to="{
                      name: 'report', query: {
                        publisher_id: entity.id, pie_group_value: 'panel',
                        pie_metric_value: 'total_amount',
                        expiry_group_value: 'supplier',
                        expiry_num_groups: 10,
                        scatter_group_value: 'procurement_method',
                        scatter_num_groups: 5
                      }
                    }">
                    <v-icon>mdi-chart-box-outline</v-icon>
                  </v-btn>
                </template>
                <span>View this buyer's insights report</span>
              </v-tooltip>
            </span>
            <span>
              <span>
                <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" large icon color="secondary" light style="text-decoration: none !important;"
                      target="_blank" :to="{ name: 'network', query: { publisher_id: entity.id } }">
                      <v-icon>mdi-graphql</v-icon>
                    </v-btn>
                  </template>
                  <span>View this buyer's network</span>
                </v-tooltip>
              </span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" large icon color="#4EB888" light :href="entity.website" target="_blank"
                    style="text-decoration: none !important;" :disabled="disableIcon(entity.website)">
                    <v-icon>mdi-web</v-icon>
                  </v-btn>
                </template>
                <span>Go to Website</span>
              </v-tooltip>
            </span>
            <span v-if="entity.metadata && entity.metadata.linkedin">
              <v-btn large icon color="#4EB888" light :href="'https://' + entity.metadata.linkedin" target="_blank"
                style="text-decoration: none !important;">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
            </span>
            <span v-if="entity.metadata && entity.metadata.twitter">
              <v-btn large icon color="#4EB888" light :href="'https://' + entity.metadata.twitter" target="_blank"
                style="text-decoration: none !important;">
                <v-icon>mdi-twitter</v-icon>
              </v-btn>
            </span>
          </v-card-title>
          <v-card-subtitle class="pt-5">
            <v-card-text v-if="entity['address']" style="color:#12253a;" class="pa-0 font-weight-normal pt-0 pb-1">
              <div>{{ entity.address }}</div>
              <div v-if="hasMetadata && entity.metadata.numEmployees && entity.metadata.numEmployees.max"
                style="color:#12253a;" class="font-weight-strong">
                <b>STAFF</b> {{ getSizeText(entity.metadata.numEmployees.max) }}
              </div>
              <div v-if="entity.metadata" class="font-weight-normal subtitle-2 pt-0 pb-0">
                <a @click="info_dialog = true">Description<v-icon color="#41a7d9"
                    class="pl-0 ml-0">mdi-menu-right</v-icon></a>
              </div>
            </v-card-text>

            <div>

              <!-- <span v-for="e in industry" :key="e">
                <router-link
                            :to="{ name: 'search', query: { industry: [entity['industry']] } }"
                          >
                  <v-chip v-if="entity['industry']"
                      class="my-0 ml-0 mr-2"
                      color="secondary"
                      label
                      text-color="secondary"
                      small
                      outlined
                >
                  <v-icon small left>
                    mdi-label
                  </v-icon>
                  {{e}}
                </v-chip>
                </router-link>
              </span> -->
              <!-- COFOG Classifications -->
              <span
                v-if="hasMetadata && entity.metadata.cofog_classifications && Array.isArray(entity.metadata.cofog_classifications)">
                <span v-for="cofog in entity.metadata.cofog_classifications" :key="cofog.code">
                  <router-link :to="{ name: 'search', query: { cofog_classification: cofog.code } }">
                    <v-chip class="my-0 ml-0 mr-2" color="secondary" label text-color="secondary" small outlined>
                      <v-icon small left>
                        mdi-label
                      </v-icon>
                      {{ cofog.name }}
                      <span v-if="cofog.is_primary" class="ml-1">
                        <v-icon x-small color="secondary">mdi-star</v-icon>
                      </span>
                    </v-chip>
                  </router-link>
                </span>
              </span>
              <span v-for="clstr in entity.clusters" :key="clstr.id">
                <router-link :to="{ name: 'cluster', params: { clusterId: clstr.id } }">
                  <v-chip v-if="clstr" class="my-0 ml-0 mr-2" color="primary" label text-color="primary" small outlined>
                    <v-icon small left>
                      mdi-hexagon-multiple
                    </v-icon>
                    {{ clstr.name }}
                  </v-chip>
                </router-link>
              </span>
            </div>

          </v-card-subtitle>


          <v-dialog v-model="show_insights_modal" scrollable max-width="1400">
            <v-card tile>
              <v-card-title class="d-flex align-center">
                <span class="text-h6 font-weight-bold d-flex align-center">
                  <v-icon class="mr-2" color="primary">mdi-lightbulb-on</v-icon>
                  Strategic Analysis
                </span>
                <v-spacer></v-spacer>
                <v-btn icon @click="show_insights_modal = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text>
                <div v-if="intelligence_loading" class="text-center py-8">
                  <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                  <div class="body-2 grey--text mt-4">Loading strategic insights...</div>
                </div>
                <v-row v-else class="pt-5">
                  <v-col cols="12" md="8">
                    <!-- Contextual Intelligence Banner -->
                    <v-card v-if="buyer_intelligence && buyer_intelligence.opportunity_score" tile class="mb-4">
                      <v-card-text class="py-3">
                        <div class="d-flex align-start">
                          <v-icon
                            :color="buyer_intelligence.opportunity_score >= 70 ? 'orange darken-2' : 'blue darken-2'"
                            class="mr-3 mt-1" size="24">
                            mdi-target
                          </v-icon>
                          <div class="flex-grow-1">
                            <div class="font-weight-bold mb-1" style="font-size: 16px;">
                              <span v-if="buyer_intelligence.opportunity_score >= 70">🎯 Target Account
                                Opportunity</span>
                              <span v-else-if="buyer_intelligence.relationship === 'target'">🎯 Target Account</span>
                              <span v-else-if="buyer_intelligence.relationship === 'customer'">✅ Existing
                                Customer</span>
                              <span v-else>📊 Account Intelligence</span>
                            </div>
                            <div class="body-2 mb-2">
                              <span v-if="buyer_intelligence.opportunity_score >= 70">
                                This buyer spends {{ formattedCurrency((buyer_intelligence.recent_activity &&
                                  buyer_intelligence.recent_activity.spend_12mo) || buyer_intelligence.annual_run_rate ||
                                  0) }}/year
                                but you have
                                {{ (buyer_intelligence.competitive_context &&
                                  buyer_intelligence.competitive_context.your_competitors_present) || 0 }} active
                                contracts.
                                They work with {{ (buyer_intelligence.competitive_context &&
                                  buyer_intelligence.competitive_context.competitors &&
                                  buyer_intelligence.competitive_context.competitors.length) || 0 }} of your competitors.
                                High strategic priority.
                              </span>
                              <span v-else-if="buyer_intelligence.relationship === 'customer'">
                                Existing customer relationship.
                                <span
                                  v-if="buyer_intelligence.competitive_context && buyer_intelligence.competitive_context.competitor_total_spend">
                                  {{ formattedCurrency(buyer_intelligence.competitive_context.competitor_total_spend) }}
                                  in
                                  competitor activity detected.
                                </span>
                              </span>
                              <span v-else>
                                Opportunity Score: {{ buyer_intelligence.opportunity_score }}/100
                                <span
                                  v-if="buyer_intelligence.market_fit && buyer_intelligence.market_fit.market_overlap_pct">
                                  | Market Overlap: {{ buyer_intelligence.market_fit.market_overlap_pct }}%
                                </span>
                              </span>
                            </div>
                            <div class="d-flex flex-wrap gap-2">
                              <v-btn small
                                :color="buyer_intelligence.opportunity_score >= 70 ? 'orange darken-2' : 'primary'" dark
                                class="text-capitalize mr-2">
                                <v-icon small left>mdi-plus</v-icon>
                                Add to Target Accounts
                              </v-btn>
                              <v-btn small outlined color="primary" class="text-capitalize mr-2">
                                <v-icon small left>mdi-bell</v-icon>
                                Set Up Alerts
                              </v-btn>
                              <v-btn small outlined color="primary" class="text-capitalize">
                                <v-icon small left>mdi-eye</v-icon>
                                View Similar Buyers
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>

                    <!-- Relevance Section -->
                    <v-card v-if="buyer_intelligence && buyer_intelligence.market_fit" tile>
                      <v-card-title class="pb-2">
                        <span class="text-h6 font-weight-bold">Relevance to Your Business</span>
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6">
                            <div class="mb-4">
                              <div class="d-flex justify-space-between align-center mb-2">
                                <span class="body-1 font-weight-medium">Market Overlap</span>
                                <span class="text-h6 font-weight-bold" style="color: #12253a;">
                                  {{ buyer_intelligence.market_fit.market_overlap_pct || 0 }}%
                                </span>
                              </div>
                              <v-progress-linear :value="buyer_intelligence.market_fit.market_overlap_pct || 0"
                                color="secondary" height="8" rounded class="mb-1"></v-progress-linear>
                              <div class="caption text--secondary">
                                <span v-if="buyer_intelligence.market_fit.market_overlap_pct">
                                  {{ Math.round((buyer_intelligence.market_fit.market_overlap_pct / 100) *
                                    ((buyer_intelligence.lifetime_metrics &&
                                      buyer_intelligence.lifetime_metrics.total_contracts) ||
                                      0)) }}
                                  of {{ (buyer_intelligence.lifetime_metrics &&
                                    buyer_intelligence.lifetime_metrics.total_contracts) || 0 }} contracts match your
                                  service
                                  keywords
                                </span>
                                <span v-else>No overlap data available</span>
                              </div>
                            </div>
                            <div v-if="buyer_intelligence.competitive_context" class="mb-4">
                              <div class="d-flex align-center mb-2">
                                <v-icon small color="orange darken-2" class="mr-2">mdi-alert-circle</v-icon>
                                <span class="body-1 font-weight-medium">Competitor Activity</span>
                                <v-chip small
                                  :color="buyer_intelligence.competitive_context.your_competitors_present >= 3 ? 'red' : buyer_intelligence.competitive_context.your_competitors_present >= 1 ? 'orange' : 'grey'"
                                  text-color="white" class="ml-2">
                                  {{ buyer_intelligence.competitive_context.your_competitors_present >= 3 ? 'HIGH' :
                                    buyer_intelligence.competitive_context.your_competitors_present >= 1 ? 'MEDIUM' :
                                      'LOW' }}
                                </v-chip>
                              </div>
                              <div
                                v-if="buyer_intelligence.competitive_context.competitors && buyer_intelligence.competitive_context.competitors.length > 0"
                                class="ml-6">
                                <div
                                  v-for="(comp, idx) in buyer_intelligence.competitive_context.competitors.slice(0, 3)"
                                  :key="idx" class="d-flex justify-space-between align-center mb-1">
                                  <span class="caption">
                                    • {{ comp.supplier }}: {{ comp.contracts }} contracts ({{
                                      formattedCurrency(comp.spend) }})
                                  </span>
                                  <v-chip v-if="idx === 0" x-small color="red" text-color="white" class="ml-2">
                                    Your #1 competitor here
                                  </v-chip>
                                </div>
                              </div>
                              <div v-else class="caption text--secondary ml-6">
                                No competitors detected in your clusters
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="mb-4">
                              <div class="d-flex align-center mb-2">
                                <span class="body-1 font-weight-medium">Your Position</span>
                                <v-chip small :color="buyer_intelligence.relationship ? 'green' : 'red'"
                                  text-color="white" class="ml-2">
                                  {{ buyer_intelligence.relationship ? buyer_intelligence.relationship.toUpperCase() :
                                    'NO PRESENCE' }}
                                </v-chip>
                              </div>
                              <div class="ml-6">
                                <div class="caption text--secondary mb-1">
                                  <span v-if="buyer_intelligence.relationship === 'customer'">
                                    Existing customer relationship
                                  </span>
                                  <span v-else-if="buyer_intelligence.relationship === 'target'">
                                    In your target accounts cluster
                                  </span>
                                  <span v-else>
                                    0 contracts won
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div v-if="buyer_intelligence.opportunity_score !== undefined">
                              <v-card
                                :color="buyer_intelligence.opportunity_score >= 70 ? 'orange darken-2' : buyer_intelligence.opportunity_score >= 40 ? 'blue darken-2' : 'grey darken-2'"
                                dark class="pa-3">
                                <div class="d-flex justify-space-between align-center mb-1">
                                  <span class="body-2 font-weight-medium">Opportunity Score</span>
                                  <span class="text-h4 font-weight-bold">{{ buyer_intelligence.opportunity_score
                                  }}/100</span>
                                </div>
                                <div class="caption" style="opacity: 0.9;">
                                  <span v-if="buyer_intelligence.opportunity_score >= 70">
                                    High spend in your categories + No existing relationship = Major opportunity
                                  </span>
                                  <span v-else-if="buyer_intelligence.opportunity_score >= 40">
                                    Moderate opportunity with some competitive presence
                                  </span>
                                  <span v-else>
                                    Limited opportunity based on current market dynamics
                                  </span>
                                </div>
                              </v-card>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <!-- AI Insights Sidebar Content -->
                    <v-card tile height="100%">
                      <v-card-title class="d-flex align-center">
                        <span class="text-subtitle-1 font-weight-bold">Insights</span>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text style="max-height: 100%; overflow-y: auto;">
                        <div v-if="buyer_intelligence">
                          <v-card
                            v-if="buyer_intelligence.yoy_changes && buyer_intelligence.yoy_changes.spend_pct && Math.abs(buyer_intelligence.yoy_changes.spend_pct) > 20"
                            class="mb-3"
                            :color="buyer_intelligence.yoy_changes.spend_pct > 0 ? 'orange lighten-5' : 'blue lighten-5'"
                            outlined>
                            <v-card-text class="py-3">
                              <div class="d-flex align-start">
                                <v-icon
                                  :color="buyer_intelligence.yoy_changes.spend_pct > 0 ? 'orange darken-2' : 'blue darken-2'"
                                  class="mr-2 mt-1">
                                  {{ buyer_intelligence.yoy_changes.spend_pct > 0 ? 'mdi-fire' : 'mdi-trending-down' }}
                                </v-icon>
                                <div>
                                  <div class="font-weight-semibold mb-1">
                                    {{ buyer_intelligence.yoy_changes.spend_pct > 0 ? '🔥 Hot Signal' : '📈 Trend Alert'
                                    }}
                                  </div>
                                  <div class="caption">
                                    <span v-if="buyer_intelligence.yoy_changes.spend_pct > 0">
                                      Activity surge: {{ Math.abs(buyer_intelligence.yoy_changes.spend_pct).toFixed(1)
                                      }}% more
                                      spend this year vs last
                                    </span>
                                    <span v-else>
                                      Spend dropped {{ Math.abs(buyer_intelligence.yoy_changes.spend_pct).toFixed(1) }}%
                                      - Shift
                                      in procurement strategy?
                                    </span>
                                  </div>
                                  <div class="caption text--secondary mt-1">
                                    → {{ buyer_intelligence.yoy_changes.spend_pct > 0 ? 'Expanding procurement operations' : 'Monitor for opportunities' }}
                                  </div>
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>

                          <v-card v-if="buyer_intelligence.expiring_12mo && buyer_intelligence.expiring_value_12mo"
                            class="mb-3" color="yellow lighten-5" outlined>
                            <v-card-text class="py-3">
                              <div class="d-flex align-start">
                                <v-icon color="yellow darken-2" class="mr-2 mt-1">mdi-alert-circle</v-icon>
                                <div>
                                  <div class="font-weight-semibold mb-1">⚠️ Risk Factor</div>
                                  <div class="caption">
                                    {{ buyer_intelligence.expiring_12mo || 0 }} contracts expiring next 12 months
                                    ({{ formattedCurrency(buyer_intelligence.expiring_value_12mo) }} at stake)
                                  </div>
                                  <div class="caption text--secondary mt-1">
                                    → High renewal activity expected
                                  </div>
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>

                          <v-card
                            v-if="buyer_intelligence.market_fit && buyer_intelligence.market_fit.category_opportunities && buyer_intelligence.market_fit.category_opportunities.length > 0"
                            class="mb-3" color="green lighten-5" outlined>
                            <v-card-text class="py-3">
                              <div class="d-flex align-start">
                                <v-icon color="green darken-2" class="mr-2 mt-1">mdi-target</v-icon>
                                <div>
                                  <div class="font-weight-semibold mb-1">🎯 Strategic Recommendation</div>
                                  <div class="caption">
                                    Target their {{ buyer_intelligence.market_fit.category_opportunities[0].category }}
                                    category -
                                    Your sweet spot with {{
                                      formattedCurrency(buyer_intelligence.market_fit.category_opportunities[0].buyer_spend)
                                    }}
                                    annual spend
                                  </div>
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>

                          <v-card
                            v-if="buyer_intelligence.competitive_context && buyer_intelligence.competitive_context.your_competitors_present >= 3"
                            class="mb-3" color="red lighten-5" outlined>
                            <v-card-text class="py-3">
                              <div class="d-flex align-start">
                                <v-icon color="red darken-2" class="mr-2 mt-1">mdi-alert</v-icon>
                                <div>
                                  <div class="font-weight-semibold mb-1">🚨 Competitive Alert</div>
                                  <div class="caption">
                                    {{ buyer_intelligence.competitive_context.your_competitors_present }} of your
                                    competitors are
                                    active here
                                  </div>
                                  <div class="caption text--secondary mt-1">
                                    → {{
                                      formattedCurrency(buyer_intelligence.competitive_context.competitor_total_spend) }}
                                    in
                                    competitor spend detected
                                  </div>
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>
                        </div>
                        <div v-else class="text-center py-8">
                          <v-icon large color="grey lighten-1" class="mb-4">mdi-lightbulb-outline</v-icon>
                          <div class="body-2 grey--text">No insights available</div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <v-divider class="my-6"
                  v-if="!intelligence_loading && buyer_competitors && buyer_competitors.competitors && buyer_competitors.competitors.length"></v-divider>

                <v-card
                  v-if="buyer_competitors && buyer_competitors.competitors && buyer_competitors.competitors.length > 0"
                  tile class="mb-4" style="border: 2px solid #ff5252;">
                  <v-card-title class="pb-2">
                    <span class="text-h6 font-weight-bold">🎯 Your Competitors</span>
                    <v-spacer></v-spacer>
                    <span class="body-2 text--secondary">
                      {{ buyer_competitors.competitor_count }} suppliers |
                      {{ formattedCurrency(buyer_competitors.total_competitor_spend) }} total
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-list>
                      <v-list-item v-for="(comp, idx) in buyer_competitors.competitors.slice(0, 5)" :key="idx"
                        class="mb-2"
                        :style="idx === 0 ? 'background-color: #ffebee; border-radius: 4px; border-left: 4px solid #f44336;' : 'background-color: #fafafa; border-radius: 4px;'">
                        <v-list-item-content>
                          <div class="d-flex justify-space-between align-center">
                            <div class="flex-grow-1">
                              <div class="d-flex align-center mb-1">
                                <span class="font-weight-semibold">{{ comp.supplier }}</span>
                                <v-chip v-if="idx === 0" x-small color="red" text-color="white" class="ml-2">
                                  ⭐ Dominant Position
                                </v-chip>
                              </div>
                              <div class="caption text--secondary">
                                {{ comp.contracts }} contracts |
                                {{ formattedCurrency(comp.total_spend) }} |
                                Avg: {{ formattedCurrency(comp.avg_contract) }}
                              </div>
                              <div class="caption mt-1">
                                <span v-if="comp.active_contracts">
                                  {{ comp.active_contracts }} active ({{ formattedCurrency(comp.active_spend) }}) |
                                </span>
                                <span v-if="comp.relationship_status">
                                  Status: {{ comp.relationship_status }} |
                                </span>
                                <span v-if="comp.years_relationship">
                                  {{ comp.years_relationship.toFixed(1) }} years relationship
                                </span>
                              </div>
                            </div>
                            <div class="d-flex flex-column gap-2 ml-4">
                              <v-btn small color="red darken-1" dark tile
                                @click="$router.push({ name: 'supplier', params: { id: comp.supplier_id } })">
                                View Profile
                              </v-btn>
                              <v-btn class="pt-2" small outlined tile color="red darken-1"
                                @click="compareSuppliers(comp)">
                                Compare
                              </v-btn>
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>

                <v-divider class="my-6"
                  v-if="!intelligence_loading && buyer_opportunities && buyer_opportunities.opportunities && buyer_opportunities.opportunities.length"></v-divider>

                <v-card
                  v-if="buyer_opportunities && buyer_opportunities.opportunities && buyer_opportunities.opportunities.length > 0"
                  tile class="mb-3" style="background: linear-gradient(to right, #e8f5e9, #c8e6c9);">
                  <v-card-title>
                    <span class="text-h6 font-weight-bold">🎯 Market Entry Opportunities</span>
                  </v-card-title>
                  <v-card-text>
                    <div class="body-2 mb-3">
                      We've identified high-value opportunities where {{ entity.name }} procures services matching your
                      capabilities but you haven't competed.
                    </div>
                    <div class="mb-4">
                      <div class="subtitle-1 font-weight-bold mb-3">Whitespace Analysis</div>
                      <v-list>
                        <v-list-item v-for="(opp, idx) in buyer_opportunities.opportunities.slice(0, 10)" :key="idx"
                          class="mb-2" style="background-color: white; border-radius: 4px;">
                          <v-list-item-content>
                            <div class="d-flex justify-space-between align-center">
                              <div class="flex-grow-1">
                                <div class="font-weight-medium mb-1">{{ opp.category }}</div>
                                <div class="caption text--secondary">
                                  {{ opp.buyer_contracts }} contracts |
                                  {{ formattedCurrency(opp.buyer_spend) }} annually |
                                  {{ opp.active_suppliers }} suppliers active
                                </div>
                                <div class="caption mt-1">
                                  Avg contract: {{ formattedCurrency(opp.avg_contract_value) }} |
                                  Opportunity Score: {{ opp.opportunity_score }}
                                </div>
                              </div>
                              <div class="text-right mr-4">
                                <div class="text-h6 font-weight-bold" style="color: #4caf50;">
                                  {{ formattedCurrency(opp.avg_contract_value) }}
                                </div>
                                <div class="caption text--secondary">Avg contract</div>
                              </div>
                              <v-btn small color="green darken-1" dark class="ml-2">
                                Analyze
                              </v-btn>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </div>
                    <div class="text-center pt-2">
                      <div class="body-2">
                        <strong>{{ buyer_opportunities.opportunity_count }}</strong> opportunities identified |
                        Total value: <strong>{{ formattedCurrency(buyer_opportunities.total_opportunity_value)
                        }}</strong>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>


          <v-row v-if="loading_stats == true" class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0">
              <v-card tile style="color:rgb(78, 184, 136);">
                <v-skeleton-loader class="py-2" type="table-thead"></v-skeleton-loader>
              </v-card>
              <v-dialog v-model="loading_stats" hide-overlay persistent width="300" lazy>
                <v-card color="secondary" dark>
                  <v-card-text>
                    Building the profile...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row v-else-if="loading_stats == false && date_aggs.length == 0" class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0">
              <v-card tile>
                <v-card-text class="text-center py-8">
                  <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-line</v-icon>
                  <div class="text-h6 grey--text text--lighten-1 mb-2">No Data Available</div>
                  <div class="body-2 grey--text">This publisher has no contract data to display.</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-else-if="loading_stats == false && date_aggs.length > 0" class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0">
              <v-card tile flat>
                <v-card-actions class="justify-end align-center flex-wrap py-2 px-3 pt-3 pb-1">
                  <v-btn-toggle v-model="contractStatsScopeUi" mandatory dense color="primary">
                    <v-btn small :value="'all'">All</v-btn>
                    <v-btn small :value="'indigenous'">Indigenous</v-btn>
                  </v-btn-toggle>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-text class="pa-0 pt-0">
                  <v-row class="ma-0 pa-0">
            <v-col cols="12" md="6" class="ma-0 pa-0">
              <v-card flat>
                <v-card-text class="pt-2 pb-0 font-weight-normal">Active Contracts</v-card-text>
                <v-divider class="mx-3"></v-divider>
                <v-row class="ma-0 pa-0">

                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Value</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsActiveContracts.stats.sum) }}
                        </div>
                        <div class="font-weight-normal body-2">
                          <router-link :to="{
                            name: 'search',
                            query: statsSearchQuery({
                              publisher_id: entity.id,
                              disposition: 'Contract Notice',
                              expiry_date_from: new Date().toISOString().split('T')[0],
                              expiry_date_to: new Date(new Date().getFullYear() + 50, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0],
                              sort_order: 'asc'
                            })
                          }">
                            {{ statsActiveContracts.stats.count }}
                            contracts</router-link>
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>

                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Highest
                        Value</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsActiveContracts.stats.max) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          Contract
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>

                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Avg Contract</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsActiveContracts.stats.avg) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          Active
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="ma-0 pa-0">
              <v-card flat>
                <v-card-text class="pt-2 pb-0 font-weight-normal">Awards - All Time</v-card-text>
                <v-divider class="mx-3"></v-divider>
                <v-row class="ma-0 pa-0">

                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Value</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsAwardTotal) }}
                        </div>
                        <div class="font-weight-normal body-2">
                          <router-link :to="{ name: 'search', query: statsSearchQuery({ publisher_id: entity.id }) }">
                            {{ statsNumNotices
                            }}<span v-if="statsNumNotices == 10000">+</span>
                            awards</router-link>
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>

                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Avg Per Year</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsAwardYearsCount ? statsAwardTotal / statsAwardYearsCount : 0) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          {{ statsAwardYearsCount }} years
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>

                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Avg Contract</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsAvgContractDisplay) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          All contracts
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="ma-0 pa-0">
              <v-card flat>
                <v-card-text class="pt-2 pb-0 font-weight-normal">Awards - Last 12 Months</v-card-text>
                <v-divider class="mx-3"></v-divider>
                <v-row class="ma-0 pa-0">
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Value</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsGrowth.current_year_total) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          <v-icon :color="growth_format(statsGrowth.spend_change_percent).color">
                            {{ growth_format(statsGrowth.spend_change_percent).icontype }}
                          </v-icon>
                          {{ growth_format(statsGrowth.spend_change_percent).change }}%
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Avg Contract</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsGrowth.curr_yr_avg_contract) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          <v-icon :color="growth_format(statsGrowth.avg_change_percent).color">
                            {{ growth_format(statsGrowth.avg_change_percent).icontype }}
                          </v-icon>
                          {{ growth_format(statsGrowth.avg_change_percent).change }}%
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Contracts</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          <router-link :to="{
                            name: 'search',
                            query: awardsLast12MonthsSearchQuery()
                          }">
                            {{ numFormatter(statsGrowth.current_year_vol) }}
                          </router-link>
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          <v-icon :color="growth_format(statsGrowth.vol_change_percent).color">
                            {{ growth_format(statsGrowth.vol_change_percent).icontype }}
                          </v-icon>
                          {{ growth_format(statsGrowth.vol_change_percent).change }}%
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="ma-0 pa-0">
              <v-card flat>
                <v-card-text class="pt-2 pb-0 font-weight-normal">Expiring - Next 12 Months</v-card-text>
                <v-divider class="mx-3"></v-divider>
                <v-row class="ma-0 pa-0">
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Value</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsExpiringSoon.next_year_total) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          <v-icon :color="growth_format(statsExpiringSoon.spend_change_percent).color">
                            {{ growth_format(statsExpiringSoon.spend_change_percent).icontype }}
                          </v-icon>
                          {{ growth_format(statsExpiringSoon.spend_change_percent).change }}%
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Avg Contract</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(statsExpiringSoon.next_yr_avg_contract) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          <v-icon :color="growth_format(statsExpiringSoon.avg_change_percent).color">
                            {{ growth_format(statsExpiringSoon.avg_change_percent).icontype }}
                          </v-icon>
                          {{ growth_format(statsExpiringSoon.avg_change_percent).change }}%
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Contracts</v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          <router-link :to="{
                            name: 'search',
                            query: statsSearchQuery({
                              publisher_id: entity.id,
                              disposition: 'Contract Notice',
                              contract_end_to: new Date().toISOString().split('T')[0],
                              contract_end_from: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0],
                              sort_order: 'asc'
                            })
                          }">
                            {{ numFormatter(statsExpiringSoon.next_year_vol) }}
                          </router-link>

                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          <v-icon :color="growth_format(statsExpiringSoon.vol_change_percent).color">
                            {{ growth_format(statsExpiringSoon.vol_change_percent).icontype }}
                          </v-icon>
                          {{ growth_format(statsExpiringSoon.vol_change_percent).change }}%
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-tabs class="pt-4 pb-1" color="rgb(18, 37, 58)" show-arrows>
            <v-tabs-slider color="rgb(255, 20, 99)"></v-tabs-slider>
            <v-tab v-if="loading_stats == false && date_aggs.length > 0">
              Analysis
            </v-tab>
            <v-tab v-if="loading_stats == false">
              Indigenous procurement
            </v-tab>
            <v-tab v-if="loading_stats == false">
              Contacts
            </v-tab>
            <v-tab v-if="loading_stats == false && (date_aggs.length > 0 || publish_activity.length > 0)">
              Recent Notices
            </v-tab>
            <v-tab v-if="loading_stats == false && open_tenders">
              Open Tenders
            </v-tab>
            <v-tab v-if="loading_stats == false && date_aggs.length > 0"
              @click="updateSupplierList({ 'publisher_id': [entity.id] }), getSupplierStats(entity.id)">
              Suppliers
            </v-tab>
            <v-tab v-if="loading_stats == false && date_aggs.length > 0">
              <span v-if="assessment_loaded" class="pr-1"><v-icon small
                  :color="transparencyColor(assessment.transparency.entity.transparency)">mdi-checkbox-blank-circle</v-icon></span>
              <span>Transparency</span>
            </v-tab>
            <v-tab v-if="entity && entity.entity_amendment_rollup">
              Amendments
            </v-tab>
            <v-tab-item v-if="loading_stats == false && date_aggs.length > 0">
              <v-row class="py-3">
                <v-col cols="12" sm="7" class="pl-md-3 pr-md-1 py-md-1 px-xs-0 py-xs-0">
                  <v-card tile flat>
                    <spending-timeline v-if="!overlay && date_aggs.length > 0" :date_aggs="date_aggs"
                      :entity_aggs="supplier_aggs" :expiry_aggs="expiry_aggs"
                      :contracting_activity="contracting_activity" :expiring_activity="expiring_activity"
                      :annual_spend="annual_spend" :entity_type="'supplier'" :metric_name="'total_amount'"
                      :units="'Amount'" :title="'Awards Over Time - Top Suppliers'" />
                    <div v-else-if="overlay" class="text-center py-8">
                      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                      <div class="body-2 grey--text mt-2">Loading chart data...</div>
                    </div>
                    <div v-else class="text-center py-8">
                      <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-line</v-icon>
                      <div class="body-2 grey--text">No data available for this chart</div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="3" class="pl-md-1 pr-md-1 py-md-1 px-xs-0 py-xs-0">
                  <v-card tile flat>
                    <graph-data-view :chartGroup="'supplier'" />
                  </v-card>
                </v-col>
                <v-col cols="12" sm="2" class="pl-md-1 pr-md-3 py-md-1 px-xs-0 py-xs-0">
                  <v-card tile flat>
                    <spending-donut v-if="!overlay && supplier_aggs.length > 0" :entity_type="'supplier'"
                      :metric_name="'total_amount'" :search="search_terms" :entity_data="supplier_aggs"
                      :title="'Awards By Supplier'" />
                    <div v-else-if="overlay" class="text-center py-8">
                      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                      <div class="body-2 grey--text mt-2">Loading chart data...</div>
                    </div>
                    <div v-else class="text-center py-8">
                      <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-donut</v-icon>
                      <div class="body-2 grey--text">No data available for this chart</div>
                    </div>
                  </v-card>
                </v-col>

                <v-col v-if="entity.gov_type != 'SA'" cols="12" sm="7" class="pl-md-3 pr-md-1 py-md-1 px-xs-0 py-xs-0">
                  <v-card tile flat>
                    <spending-timeline v-if="!overlay && date_aggs.length > 0" :date_aggs="date_aggs"
                      :expiry_aggs="expiry_aggs" :contracting_activity="contracting_activity"
                      :expiring_activity="expiring_activity" :entity_aggs="category_aggs" :annual_spend="annual_spend"
                      :entity_type="'major_category'" :metric_name="'total_amount'" :units="'Amount'"
                      :title="'Awards Over Time - Top Categories'" />
                    <div v-else-if="overlay" class="text-center py-8">
                      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                      <div class="body-2 grey--text mt-2">Loading chart data...</div>
                    </div>
                    <div v-else class="text-center py-8">
                      <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-line</v-icon>
                      <div class="body-2 grey--text">No data available for this chart</div>
                    </div>
                  </v-card>
                </v-col>
                <v-col v-if="entity.gov_type != 'SA'" cols="12" sm="3" class="pl-md-1 pr-md-1 py-md-1 px-xs-0 py-xs-0">
                  <v-card tile flat>
                    <graph-data-view :chartGroup="'parent_category'" />
                  </v-card>
                </v-col>
                <v-col v-if="entity.gov_type != 'SA'" cols="12" sm="2" class="pl-md-1 pr-md-3 py-md-1 px-xs-0 py-xs-0">
                  <v-card tile flat>
                    <spending-donut v-if="!overlay && category_aggs.length > 0" :entity_type="'major_category'"
                      :metric_name="'total_amount'" :search="search_terms" :entity_data="category_aggs"
                      :title="'Awards By Category'" />
                    <div v-else-if="overlay" class="text-center py-8">
                      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                      <div class="body-2 grey--text mt-2">Loading chart data...</div>
                    </div>
                    <div v-else class="text-center py-8">
                      <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-donut</v-icon>
                      <div class="body-2 grey--text">No data available for this chart</div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="loading_stats == false">
              <v-row align="stretch" class="indigenous-procurement-row-top" style="background-color:#f5f5f5">
                <v-col cols="12" class="pt-3 pr-md-1 d-flex">
                  <v-card tile flat class="mb-3 flex-grow-1 d-flex flex-column" style="width: 100%;">
                    <v-card-title class="py-2">
                      <span class="font-weight-normal subtitle-1" style="color:#12253a;">
                        {{ indigenousStats.awards.title }}
                      </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle class="pt-3 pb-2">
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <span class="mr-3">
                          <v-icon :color="growth_format(getIndigenousGrowth('awards', 'volume')).color">
                            {{ growth_format(getIndigenousGrowth('awards', 'volume')).icontype }}
                          </v-icon>
                          {{ growth_format(getIndigenousGrowth('awards', 'volume')).change }}% change in volume
                        </span>
                        <span>
                          <v-icon :color="growth_format(getIndigenousGrowth('awards', 'value')).color">
                            {{ growth_format(getIndigenousGrowth('awards', 'value')).icontype }}
                          </v-icon>
                          {{ growth_format(getIndigenousGrowth('awards', 'value')).change }}% change in total value
                        </span>
                      </div>
                    </v-card-subtitle>
                    <v-card-text class="pt-0 flex-grow-1 d-flex flex-column">
                      <v-card tile flat class="flex-grow-1 d-flex flex-column">
                        <bar-chart-v2 :bar_chart_data="getIndigenousBarData('awards')"
                          :lineSeriesLabel="'Number of notices'"
                          :barSeriesLabel="'Total contracted amount'"
                          :countsAxisTitle="'Notices'"
                          :amountsAxisTitle="'Contract value'"
                          :xAxisTitle="'Calendar year'"
                          :metric_name="'doc_count'"
                          :chart-click="(e, els) => onIndigenousBarChartClick(e, els, 1)" />
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pt-3 px-md-1 d-flex">
                  <v-card tile flat class="mb-3 flex-grow-1 d-flex flex-column" style="width: 100%;">
                    <v-card-title class="py-2">
                      <span class="font-weight-normal subtitle-1" style="color:#12253a;">
                        {{ indigenousStats.suppliers.title }}
                      </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle class="pt-3 pb-2">
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <span class="mr-3">
                          <v-icon :color="growth_format(getIndigenousGrowth('suppliers', 'volume')).color">
                            {{ growth_format(getIndigenousGrowth('suppliers', 'volume')).icontype }}
                          </v-icon>
                          {{ growth_format(getIndigenousGrowth('suppliers', 'volume')).change }}% change in new suppliers
                        </span>
                        <span class="text--secondary"> vs prior year</span>
                      </div>
                    </v-card-subtitle>
                    <v-card-text class="pt-0 flex-grow-1 d-flex flex-column">
                      <v-card tile flat class="flex-grow-1 d-flex flex-column">
                        <bar-chart-v2 layout="bar_single_axis"
                          :bar_chart_data="getIndigenousBarData('suppliers')"
                          :barSeriesLabel="'Number of new suppliers engaged'"
                          :xAxisTitle="'Calendar year'"
                        />
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  class="pt-3 pl-md-1 d-flex align-stretch indigenous-prop-col"
                >
                  <v-card
                    tile
                    flat
                    class="mb-3 flex-grow-1 d-flex flex-column indigenous-prop-panel-card"
                    style="width: 100%; min-height: 0;"
                  >
                    <graph-data-view :chartGroup="'indigenous_awards'" />
                  </v-card>
                </v-col>
              </v-row>
              <v-row align="stretch" style="background-color:#f5f5f5">
                <v-col cols="12" md="6" class="pt-0 pr-md-1 d-flex">
                  <v-card tile flat class="mb-3 flex-grow-1 d-flex flex-column" style="width: 100%;">
                    <v-card-title class="py-2">
                      <span class="font-weight-normal subtitle-1" style="color:#12253a;">
                        Indigenous share of spend vs policy target
                      </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle class="pt-3 pb-2">
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <template v-if="!complianceSelectedFyNoticeGrowth && !complianceSelectedFySpendGrowth">
                          <span class="text--secondary">Select a later calendar year (not the first in the chart) to see
                            year-on-year change.</span>
                        </template>
                        <template v-else>
                          <span v-if="complianceSelectedFyNoticeGrowth" class="mr-3">
                            <v-icon :color="complianceSelectedFyNoticeGrowth.color">
                              {{ complianceSelectedFyNoticeGrowth.icontype }}
                            </v-icon>
                            {{ complianceSelectedFyNoticeGrowth.change }}% change in indigenous share of notices
                          </span>
                          <span v-else class="mr-3 text--secondary">Notices: no prior year in range</span>
                          <span v-if="complianceSelectedFySpendGrowth">
                            <v-icon :color="complianceSelectedFySpendGrowth.color">
                              {{ complianceSelectedFySpendGrowth.icontype }}
                            </v-icon>
                            {{ complianceSelectedFySpendGrowth.change }}% change in indigenous share of spend
                          </span>
                          <span v-else class="text--secondary">Spend share: no prior year in range</span>
                        </template>
                      </div>
                    </v-card-subtitle>
                    <v-card-text class="pt-0 flex-grow-1 d-flex flex-column">
                      <p class="caption mb-1 flex-shrink-0" style="color:#5f6368;">
                        Selected year: indigenous spend as a share of total contract spend vs the policy target.
                      </p>
                      <v-select v-model="complianceDonutSelectedFy" :items="complianceDonutFyOptions" dense outlined
                        hide-details label="Year (gauge)" class="mb-2 flex-shrink-0"
                        :disabled="complianceDonutFyOptions.length === 0" @change="onComplianceDonutFyChange" />
                      <div class="flex-grow-1 d-flex align-center" style="min-height: 0;">
                        <compliance-gauge style="width: 100%;" :percent="complianceGaugePercent"
                          :target="indigenousStats.compliance.policy.target_percent || 4"
                          :fy-label="complianceDonutSelectedFy || ''" :changed="indigenousDonutChange" />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6" class="pt-0 pl-md-1 d-flex">
                  <v-card tile flat class="mb-3 flex-grow-1 d-flex flex-column" style="width: 100%;">
                    <v-card-title class="py-2">
                      <span class="font-weight-normal subtitle-1" style="color:#12253a;">
                        Indigenous share trend vs policy
                      </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-3 flex-grow-1 d-flex flex-column">
                      <p class="caption mb-1 flex-shrink-0" style="color:#5f6368;">
                        All years: indigenous share of contract spend. The dashed line is the policy target; bars at
                        or above
                        it meet the target for that year.
                      </p>
                      <div class="flex-grow-1" style="min-height: 0;">
                        <compliance-trend-bar style="width: 100%;" :labels="indigenousStats.compliance.bar.labels"
                          :values="indigenousStats.compliance.bar.amounts"
                          :fy-rows="indigenousStats.compliance.donutFySpend"
                          :target="indigenousStats.compliance.policy.target_percent || 4"
                          :changed="indigenousDonutChange" />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="loading_stats == false">
              <v-row style="background-color:#f5f5f5">
                <v-col cols="12" class="pt-3">
                  <contact-table class="pb-3 pt-0 pl-0 pr-0" :publisher_id="$route.params.id" />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="loading_stats == false && (date_aggs.length > 0 || publish_activity.length > 0)">
              <v-row style="background-color:#f5f5f5">
                <v-col cols="12" class="pt-3">
                  <v-skeleton-loader v-if="overlay" type="table-tbody"></v-skeleton-loader>
                  <results-table-vuetify v-else class="pb-3 pt-0 pl-0 pr-0" :hit_info="hit_info" :tenders="tenders"
                    :hide_pagination="true" />
                  <v-overlay absolute="true" :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="loading_stats == false && open_tenders">
              <v-row style="background-color:#f5f5f5">
                <v-col cols="12" class="pt-3">
                  <v-skeleton-loader v-if="overlay" type="table-tbody"></v-skeleton-loader>
                  <results-table-vuetify v-else class="pb-3 pt-0 pl-0 pr-0" :hit_info="hit_info" :tenders="open_tenders"
                    :hide_pagination="true" />
                  <v-overlay absolute="true" :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="loading_stats == false && date_aggs.length > 0">
              <v-row style="background-color:#f5f5f5">
                <v-col cols="12" md="12" class="mt-1 pt-3 pb-1">
                  <v-card v-if="supplier_stats_loaded" flat tile width="100%">
                    <v-card flat tile width="100%">
                      <v-row class="ma-0 pa-0">
                        <v-col cols="2" class="ma-0 pa-0">
                          <v-card tile flat class="py-0 my-0">
                            <v-card-title class="font-weight-normal body-2" style="color:#12253a;">Total</v-card-title>
                            <v-card-subtitle>
                              <div class="font-weight-medium text-h6" style="color:#12253a;">
                                <a :class="filterColour('all_entities')"
                                  @click="selectedFilter = 'all_entities', updateSupplierList({ 'publisher_id': [entity.id] })">{{
                                    supplier_stats.total_suppliers }}</a>
                              </div>
                              <div class="font-weight-normal body-2" style="color:#12253a;">
                                Suppliers
                              </div>
                            </v-card-subtitle>
                          </v-card>
                        </v-col>
                        <v-col cols="2" class="ma-0 pa-0">
                          <v-card tile flat class="py-0 my-0">
                            <v-card-title class="font-weight-normal body-2"
                              style="color:#12253a;">Current</v-card-title>
                            <v-card-subtitle>
                              <div class="font-weight-medium text-h6" style="color:#12253a;">
                                <a :class="filterColour('current_entities')" @click="selectedFilter = 'current_entities', updateSupplierList({
                                  'publisher_id': [entity.id],
                                  expiry_date_from: new Date().toISOString().split('T')[0],
                                  expiry_date_to: new Date(new Date().getFullYear() + 100, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0]
                                })">
                                  {{ supplier_stats.current_suppliers }}
                                </a>
                              </div>
                              <div class="font-weight-normal body-2" style="color:#12253a;">
                                Suppliers
                              </div>
                            </v-card-subtitle>
                          </v-card>
                        </v-col>
                        <v-col cols="2" class="ma-0 pa-0">
                          <v-card tile flat class="py-0 my-0">
                            <v-card-title class="font-weight-normal body-2" style="color:#12253a;">New - 12
                              Months</v-card-title>
                            <v-card-subtitle>
                              <div class="font-weight-medium text-h6">
                                <a :class="filterColour('new_entities_ytd')" @click="selectedFilter = 'new_entities_ytd', updateSupplierList({
                                  'publisher_id': [entity.id],
                                  'result_filter':
                                  {
                                    'filter_name': 'new_entities_ytd',
                                    'filter_target_type': 'publisher',
                                    'filter_target_id': [entity.id]
                                  }
                                })">
                                  {{ supplier_stats.current_year }}
                                </a>

                              </div>
                              <div class="font-weight-normal body-2" style="color:#12253a;">
                                <v-icon :color="growth_format(supplier_stats.per_change).color">
                                  {{ growth_format(supplier_stats.per_change).icontype }}
                                </v-icon>
                                {{ growth_format(supplier_stats.per_change).change }}%
                              </div>
                            </v-card-subtitle>
                          </v-card>
                        </v-col>
                        <v-col cols="2" class="ma-0 pa-0">
                          <v-card tile flat class="py-0 my-0">
                            <v-card-title class="font-weight-normal body-2" style="color:#12253a;"><span>Repeat
                                Suppliers</span>
                              <v-tooltip left max-width="250">
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small v-on="on" icon target="_blank"
                                    href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                                    <v-icon small color="primary">mdi-information-outline</v-icon>
                                  </v-btn>
                                </template>
                                <span>Suppliers that have contracted more than once with this entity.</span>
                                <br />
                                Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more
                                information.
                              </v-tooltip>
                            </v-card-title>
                            <v-card-subtitle>
                              <div class="font-weight-medium text-h6" style="color:#12253a;">
                                <a :class="filterColour('repeat_entities')" @click="selectedFilter = 'repeat_entities', updateSupplierList({
                                  'publisher_id': [entity.id],
                                  'result_filter':
                                  {
                                    'filter_name': 'repeat_entities',
                                    'filter_target_type': 'publisher',
                                    'filter_target_id': [entity.id]
                                  }
                                })">
                                  {{ growth_format(Math.round(supplier_stats.num_suppliers_with_multiple_deals /
                                    supplier_stats.total_suppliers * 100)).change }}%
                                </a>
                              </div>
                              <div class="font-weight-normal body-2" style="color:#12253a;">
                                {{ supplier_stats.num_suppliers_with_multiple_deals }}
                              </div>
                            </v-card-subtitle>
                          </v-card>
                        </v-col>
                        <v-col cols="2" class="ma-0 pa-0">
                          <v-card tile flat class="py-0 my-0">
                            <v-card-title class="font-weight-normal body-2" style="color:#12253a;"><span>Exclusive
                                Suppliers</span>
                              <v-tooltip left max-width="250">
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small v-on="on" icon target="_blank"
                                    href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                                    <v-icon small color="primary">mdi-information-outline</v-icon>
                                  </v-btn>
                                </template>
                                <span>Suppliers that have only contracted with this entity.</span>
                                <br />
                                Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more
                                information.
                              </v-tooltip>
                            </v-card-title>
                            <v-card-subtitle>
                              <div class="font-weight-medium text-h6" style="color:#12253a;">
                                <a :class="filterColour('exclusive_entities')" @click="selectedFilter = 'exclusive_entities', updateSupplierList({
                                  'publisher_id': [entity.id],
                                  'result_filter':
                                  {
                                    'filter_name': 'exclusive_entities',
                                    'filter_target_type': 'publisher',
                                    'filter_target_id': [entity.id]
                                  }
                                })">
                                  {{ growth_format(Math.round(supplier_stats.sole_source_count /
                                    supplier_stats.total_suppliers *
                                    100)).change }}%</a>

                              </div>
                              <div class="font-weight-normal body-2" style="color:#12253a;">
                                {{ supplier_stats.sole_source_count }}
                              </div>
                            </v-card-subtitle>
                          </v-card>
                        </v-col>
                        <v-col cols="2" class="ma-0 pa-0">
                          <v-card tile flat class="py-0 my-0">
                            <v-card-title class="font-weight-normal body-2" style="color:#12253a;"><span>SMEs</span>
                              <v-tooltip left max-width="250">
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small v-on="on" icon target="_blank"
                                    href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                                    <v-icon small color="primary">mdi-information-outline</v-icon>
                                  </v-btn>
                                </template>
                                <span>The estimate of SME suppliers is an indication of the percentage of Small and
                                  Medium
                                  Enterprise suppliers to the entity. It is calculated using automatically curated
                                  profile data
                                  for suppliers in Tendertrace and validated by humans.
                                  The sample used in this calculation represents {{
                                    growth_format(Math.round(supplier_stats.sme_stats.total_matched /
                                      supplier_stats.total_suppliers
                                      * 100)).change }}% of the entity's supplier base. </span>
                                <br />
                                Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more
                                information.
                              </v-tooltip>
                            </v-card-title>
                            <v-card-subtitle>
                              <div class="font-weight-medium text-h6" style="color:#12253a;">
                                {{ growth_format(supplier_stats.sme_stats.sme_percent).change }}%
                              </div>
                              <div class="font-weight-normal body-2" style="color:#12253a;">
                                Estimated
                              </div>
                            </v-card-subtitle>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <profile-members :startIndex="2" :profile_id="entity.id" :profile_name="entity.name"
                    :profile_type="'publisher'" :entity_type="'supplier'" :key="supplier_list_change"
                    :query="supplier_list_query.query"></profile-members>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="assessment_loaded">
              <v-row class="py-3">
                <v-col cols="12" md="4" class="pr-md-1 px-xs-0 py-xs-0">
                  <v-card tile min-height="500">
                    <v-card-title class="py-1">
                      <span class="font-weight-normal subtitle-1 py-2" style="color:#12253a;">Overall
                        Transparency</span>
                      <v-tooltip left max-width="250">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small v-on="on" icon target="_blank"
                            href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                            <v-icon small color="primary">mdi-information-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>The Transparency Score is calculated and aggregated based on global best practice public
                          sector
                          procurement integrity and transparency factors. In Australia, procurement transparency
                          standards and
                          obligations vary between jurisdictions. Where possible, these rules have been incorporated
                          into the
                          calculations.</span>
                        <br />
                        Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more
                        information.
                      </v-tooltip>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle class="text-center">
                      <span class="pr-1"><v-icon small
                          :color="transparencyColor(assessment.transparency.entity.transparency)">mdi-checkbox-blank-circle</v-icon></span>
                      <span>{{ entity.name }}</span>
                      <span class="pl-3 pr-1"><v-icon small
                          :color="transparencyColor(assessment.transparency.jurisdiction_benchmark.transparency)">mdi-checkbox-blank-circle</v-icon></span>
                      <span>{{ entity.gov_type }}</span>
                      <span class="pl-3 pr-1"><v-icon small
                          :color="transparencyColor(assessment.transparency.country_benchmark.transparency)">mdi-checkbox-blank-circle</v-icon></span>
                      <span>National</span>
                    </v-card-subtitle>
                    <transparency-bar class="pt-0"
                      :transparency="{ 'name': entity.name, 'value': assessment.transparency.entity.transparency }"
                      :jurisdictionTransparency="{ 'name': entity.gov_type, 'value': assessment.transparency.jurisdiction_benchmark.transparency }"
                      :nationalTransparency="{ 'name': 'National', 'value': assessment.transparency.country_benchmark.transparency }" />
                  </v-card>
                </v-col>
                <v-col cols="12" md="8" class="pl-md-1 px-xs-0 py-xs-0">
                  <v-card tile min-height="500">
                    <v-card-title class="py-1">
                      <span class="font-weight-normal subtitle-1 py-2" style="color:#12253a;">Transparency
                        Factors</span>
                      <v-tooltip left max-width="250">
                        <template v-slot:activator="{ on }">
                          <v-btn x-small v-on="on" icon target="_blank"
                            href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                            <v-icon small color="primary">mdi-information-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>The Transparency Score is calculated and aggregated based on global best practice public
                          sector
                          procurement integrity and transparency factors. In Australia, procurement transparency
                          standards and
                          obligations vary between jurisdictions. Where possible, these rules have been incorporated
                          into the
                          calculations.</span>
                        <br />
                        Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more
                        information.
                      </v-tooltip>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle class="text-center">
                      <span class="pr-1"><v-icon small color="primary">mdi-checkbox-blank-circle</v-icon></span>
                      <span>{{ entity.name }}</span>
                      <span class="pl-3 pr-1"><v-icon small color="secondary">mdi-checkbox-blank-circle</v-icon></span>
                      <span>{{ entity.gov_type }}</span>
                      <span class="pl-3 pr-1"><v-icon small
                          color="rgb(255, 231, 10)">mdi-checkbox-blank-circle</v-icon></span>
                      <span>National</span>
                    </v-card-subtitle>
                    <transparency-spider :data="{ 'payload': assessment.transparency.entity, 'name': entity.name }"
                      :benchmarkData="{ 'payload': assessment.transparency.jurisdiction_benchmark, 'name': entity.gov_type }"
                      :nationalBenchmarkData="{ 'payload': assessment.transparency.country_benchmark, 'name': 'National' }" />
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="entity && entity.entity_amendment_rollup">
              <v-row style="background-color:#f5f5f5">
                <v-col cols="12" class="pt-3">
                  <v-card flat tile>
                    <v-card-text class="caption">
                      This analysis compares the relative value of the <b>first amendment</b> of the entity's contracts
                      with the
                      relative value of initial contract amendments in the market along with the relative duration
                      between the
                      start of the contract and the date of the first amendment.
                      Understanding these comparisons can provide an indication of the tendency of the entity to enter
                      into the
                      first amendment of a contract earlier than the norm, or for a higher relative value than the norm.
                    </v-card-text>
                  </v-card>
                  <amendment-analysis :item="entity" :entity_name="entity.name"></amendment-analysis>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="info_dialog" max-width="500px" max-height="400px" hide-overlay>
      <v-card>
        <v-card-title class="subtitle-1 grey lighten-2">
          About {{ entity.name }}
        </v-card-title>

        <v-card-text class="py-2">
          {{ entity.metadata && entity.metadata.description ? entity.metadata.description : 'No description available'
          }}
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" text @click="info_dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  entitySearch,
  histogramSearch,
  fetchNews,
  executeSearch,
  entityAssessment,
  supplierStats,
  fetchBuyerIntelligence,
  fetchBuyerCompetitors,
  fetchBuyerOpportunities
} from "../APIManager.js";
import { getCurrentUserProfile } from "../APIManager.js";
import TransparencySpider from "../TransparencySpider.vue";
import TransparencyBar from "../TransparencyBar.vue";
import NewsLoader from "../NewsLoader.vue";
import { growth_format, numFormatter, formattedCurrency, govColor, transparencyColor } from "../Utils.js";
import ProfileMembers from "../ProfileMembers.vue";
import GraphDataView from "../GraphDataView.vue";
import { bus } from "../../main.js";
import SpendingTimeline from "../SpendingTimeline.vue";
import SpendingDonut from "../SpendingDonut.vue";
import BarChartV2 from "../BarChartV2.vue";
import ComplianceGauge from "../ComplianceGauge.vue";
import ComplianceTrendBar from "../ComplianceTrendBar.vue";
import ContactTable from "../entities/ContactTable.vue";
import RecentNews from "../RecentNews.vue";
import ResultsTable from "../ResultsTable.vue";
import ResultsTableVuetify from "../ResultsTableVuetify.vue"
import ClusterSelect from "../ClusterSelect.vue";
import AmendmentAnalysis from "../AmendmentAnalysis.vue";

export default {
  components: {
    //NewsLoader,
    //EntityOverview,
    SpendingDonut,
    BarChartV2,
    ComplianceGauge,
    ComplianceTrendBar,
    SpendingTimeline,
    GraphDataView,
    ResultsTableVuetify,
    ContactTable,
    ClusterSelect,
    TransparencySpider,
    TransparencyBar,
    ProfileMembers,
    AmendmentAnalysis
  },
  props: {
    entity: {},
    current_search: {},
    entity_id: String()
    //results_drawer: Boolean
  },
  data() {
    return {

      selectedFilter: 'all_entities',
      supplier_list_query: { "query": "" },
      expiring_activity: [],
      expiry_aggs: [],
      info_dialog: false,
      hit_info: {},
      tenders: [""],
      overlay: false,
      tabs: null,
      absolute: true,
      entity_panel: -9,
      entity_panels: [],
      panel_clicked: false,
      //current_index: 0,
      index: Number, //use the exp panel index as key so that we can cache the data
      profiles: [],
      mounted: false,
      entity_type: "publisher",
      total_amt_metric: "total_amount",
      search: {},
      category_aggs: [],
      date_aggs: [],
      supplier_aggs: [],
      contracting_activity: [],
      publish_activity: [],
      annual_spend: [],
      avg_contract: Number,
      /** Stats strip: all vs indigenous profile aggregates */
      contractStatsScopeUi: "all",
      loading_stats: false,
      industry: [],
      assessment_loaded: false,
      supplier_stats_loaded: false,
      metadata_loaded: false,
      assessment: {},
      supplier_stats: {},
      supplier_list_change: Number,
      // Profile Intelligence data
      buyer_intelligence: null,
      buyer_competitors: null,
      buyer_opportunities: null,
      intelligence_loading: false,
      show_insights_modal: false,
      indigenousDonutChange: 0,
      /** Selected calendar year for indigenous compliance donut (Indigenous vs other spend). */
      complianceDonutSelectedFy: null,
      indigenousStats: {
        awards: {
          title: "Contract notices with indigenous suppliers",
          headline: { volume: 0, value: 0 },
          growth: { volume: 0, value: 0 },
          bar: { labels: [], counts: [], amounts: [] },
          donut: { labels: [], values: [] }
        },
        suppliers: {
          title: "Indigenous suppliers engaged (by contract value)",
          headline: { volume: 0, value: 0 },
          growth: { volume: 0, value: 0 },
          bar: { labels: [], counts: [], amounts: [] },
          donut: { labels: [], values: [] }
        },
        compliance: {
          title: "Indigenous share of spend vs policy target",
          headline: { volume: 0, value: 0 },
          growth: { volume: 0, value: 0 },
          policy: {
            target_percent: 4,
            current_spend_percent: 0,
            previous_spend_percent: 0,
            fy_total_spend: 0,
            fy_indigenous_spend: 0,
            fy_target_spend: 0,
            awards_total: 0,
            awards_indigenous: 0
          },
          bar: { labels: [], counts: [], amounts: [] },
          donut: { labels: [], values: [] },
          donutFySpend: []
        }
      }
    };
  },

  computed: {
    selected() {
      return [this.entity.id];
    },
    complianceDonutFyOptions() {
      const rows = this.indigenousStats.compliance.donutFySpend;
      if (rows && rows.length) {
        return rows.map((r) => r.label);
      }
      const bar = this.indigenousStats.compliance.bar;
      if (bar && bar.labels && bar.labels.length) {
        return bar.labels;
      }
      return [];
    },
    indigenousStatCards() {
      return Object.keys(this.indigenousStats).map((key) => ({
        key,
        title: this.indigenousStats[key].title
      }));
    },

    hasMetadata() {
      return this.entity && this.entity.metadata && this.metadata_loaded;
    },
    complianceGaugePercent() {
      const rows = this.indigenousStats.compliance.donutFySpend;
      const fy = this.complianceDonutSelectedFy;
      if (rows && rows.length && fy) {
        const row = rows.find((r) => r.label === fy);
        if (row) {
          const total = this.toNumber(row.totalSpend);
          const indigenous = this.toNumber(row.indigenousSpend);
          return total ? Number(((indigenous / total) * 100).toFixed(2)) : 0;
        }
      }
      return this.indigenousStats.compliance.policy.current_spend_percent || 0;
    },
    /** YoY change for indigenous share of notices vs the prior calendar year in the series (matches gauge year). */
    complianceSelectedFyNoticeGrowth() {
      const v = this.getComplianceYoYForSelectedFy("volume");
      if (v === null) {
        return null;
      }
      return growth_format(v);
    },
    /** YoY change for indigenous share of spend vs the prior calendar year in the series (matches gauge year). */
    complianceSelectedFySpendGrowth() {
      const v = this.getComplianceYoYForSelectedFy("value");
      if (v === null) {
        return null;
      }
      return growth_format(v);
    },
    /** Indigenous-only aggregates from profile API (`entity.indigenous_aggregates`). */
    entityIndigenousAggregates() {
      const e = this.entity;
      if (!e || typeof e !== "object") return null;
      const agg = e.indigenous_aggregates;
      if (agg == null || typeof agg !== "object") return null;
      return agg;
    },
    /** Profile slice for the contract stats strip: all notices vs indigenous aggregates (same shapes). */
    contractStatsSrc() {
      const e = this.entity;
      if (!e) return null;
      const ind = this.entityIndigenousAggregates;
      if (this.contractStatsScopeUi === "indigenous" && ind) {
        return ind;
      }
      return e;
    },
    statsGrowth() {
      const src = this.contractStatsSrc;
      return (src && src.growth) || {};
    },
    statsActiveContracts() {
      const src = this.contractStatsSrc;
      const ac = src && src.active_contracts;
      if (ac && ac.stats) return ac;
      return { stats: { sum: 0, max: 0, avg: 0, count: 0 } };
    },
    statsExpiringSoon() {
      const src = this.contractStatsSrc;
      return (src && src.expiring_soon) || {};
    },
    statsAwardTotal() {
      const src = this.contractStatsSrc;
      if (!src || src.award_total == null) return 0;
      return src.award_total;
    },
    statsNumNotices() {
      const src = this.contractStatsSrc;
      if (!src || src.num_notices == null) return 0;
      return src.num_notices;
    },
    /** Awards — All Time year count: indigenous slice uses `awards_by_year` on `contractStatsSrc`; otherwise histogram buckets. */
    statsAwardYearsCount() {
      const src = this.contractStatsSrc;
      if (
        this.contractStatsScopeUi === "indigenous" &&
        this.entityIndigenousAggregates &&
        src &&
        Array.isArray(src.awards_by_year) &&
        src.awards_by_year.length > 0
      ) {
        return src.awards_by_year.length;
      }
      return this.date_aggs.length || 0;
    },
    /** Avg contract for stats card: histogram aggregation (all) or indigenous `active_contracts.stats.avg` from `contractStatsSrc`. */
    statsAvgContractDisplay() {
      if (this.contractStatsScopeUi === "indigenous" && this.entityIndigenousAggregates) {
        const src = this.contractStatsSrc;
        const avg =
          src &&
          src.active_contracts &&
          src.active_contracts.stats &&
          src.active_contracts.stats.avg;
        return avg != null ? avg : 0;
      }
      return this.avg_contract || 0;
    }
  },


  mounted() {
    ////////////console.log("PRZOfILE: ", this.entity["transparency"]);
    var ind = this.entity["industry"];
    if (ind && ind.includes(","))
      this.industry = ind.split(',');
    else
      this.industry[0] = ind
    this.overlay = true;
    this.loadProfile();
  },

  watch: {
    $route(to, from) {
      //this.reset_aggs();
      //this.loadProfile();
    }

  },

  methods: {

    growth_format,
    numFormatter,
    formattedCurrency,
    govColor,
    transparencyColor,
    /** Merge search query with indigenous filter when the stats strip scope is Indigenous. */
    statsSearchQuery(baseQuery) {
      const q = baseQuery && typeof baseQuery === "object" ? { ...baseQuery } : {};
      if (this.contractStatsScopeUi === "indigenous") {
        q.isindigenous = true;
      }
      return q;
    },
    /** Drill-down for Awards — Last 12 Months: API date window + contract notices only. */
    awardsLast12MonthsSearchQuery() {
      const window = this.statsGrowth.current_year;
      const query = {
        publisher_id: this.entity.id,
        disposition: "Contract Notice",
        sort_order: "asc",
      };
      if (window && window.from != null && window.to != null) {
        query.contract_start_from = String(window.from).slice(0, 10);
        query.contract_start_to = String(window.to).slice(0, 10);
      } else {
        query.contract_start_to = new Date().toISOString().split("T")[0];
        query.contract_start_from = new Date(
          new Date().getFullYear() - 1,
          new Date().getMonth(),
          new Date().getDate()
        ).toISOString().split("T")[0];
      }
      return this.statsSearchQuery(query);
    },
    getIndigenousDataSource() {
      return {
        label: "From search",
        color: "green darken-1"
      };
    },
    getCompliancePolicySubtext() {
      const policy = this.indigenousStats.compliance.policy;
      const target = policy.target_percent;
      const delta = policy.current_spend_percent - target;
      const abs = Math.abs(delta).toFixed(1);
      const versus =
        delta >= 0
          ? `${abs} percentage points above the ${target}% target`
          : `${abs} percentage points below the ${target}% target`;
      return `Policy asks for at least ${target}% of contract spend with indigenous suppliers.`;
    },
    getIndigenousGrowth(statKey, kind) {
      const growth = this.indigenousStats[statKey].growth;
      return growth[kind] || growth.volume || growth.value || 0;
    },
    getIndigenousBarData(statKey) {
      const bar = this.indigenousStats[statKey].bar;
      if (bar.labels) {
        return { labels: bar.labels, counts: bar.counts, amounts: bar.amounts };
      }
      const data = bar.value || bar.volume || bar;
      return { labels: data.labels, counts: data.counts, amounts: data.amounts };
    },

    /** Normalize chart / URL labels to a four-digit calendar year (legacy `FY26`-style accepted). */
    calendarYearLabelToYearString(label) {
      if (label === null || label === undefined) {
        return "";
      }
      const raw = String(label).trim();
      const y4 = /^(\d{4})$/.exec(raw);
      if (y4) {
        return y4[1];
      }
      const fy4 = /^FY\s*(\d{4})$/i.exec(raw);
      if (fy4) {
        return fy4[1];
      }
      const fy2 = /^FY\s*(\d{2})$/i.exec(raw);
      if (fy2) {
        return String(2000 + parseInt(fy2[1], 10));
      }
      const asNum = Number(raw);
      if (Number.isFinite(asNum) && asNum >= 1900 && asNum <= 2100) {
        return String(Math.trunc(asNum));
      }
      return "";
    },

    calendarYearToJanDecDateBounds(yearStr) {
      const y = Number(yearStr);
      if (!Number.isFinite(y) || y < 1900 || y > 2100) {
        return null;
      }
      return {
        from: `${y}-01-01`,
        to: `${y}-12-31`
      };
    },

    buildIndigenousAwardsSearchQuery(xLabel) {
      const cy = this.calendarYearLabelToYearString(xLabel);
      const bounds = cy ? this.calendarYearToJanDecDateBounds(cy) : null;
      const query = JSON.parse(JSON.stringify(this.$route.query));
      if (this.$route.name === "entity") {
        query.publisher_id = this.$route.params.id;
      }
      if (this.$route.name === "supplier") {
        query.supplier_id = this.$route.params.id;
      }
      if (this.$route.name === "category") {
        query.category_id = this.$route.params.id;
      }
      if (this.$route.name === "parent_category") {
        query.parent_category_id = this.$route.params.id;
      }
      query.type = "indigenous_awards";
      query.disposition = "Contract Notice";
      query.isindigenous = true;
      query.sort_field = "contract_start";
      query.sort_order = "desc";
      delete query.contract_year_from;
      delete query.contract_year_to;
      delete query.expiry_date_from;
      delete query.expiry_date_to;
      if (bounds) {
        query.contract_start_from = bounds.from;
        query.contract_start_to = bounds.to;
      }
      return query;
    },

    onIndigenousBarChartClick(event, activeElements, preferredBarDatasetIndex = 1) {
      if (!activeElements || !activeElements.length) {
        return;
      }
      const otherIndex = preferredBarDatasetIndex === 1 ? 0 : 1;
      /* Prefer bar dataset for drill-down; index differs by chart layout (awards vs suppliers). */
      const pt =
        activeElements.find(el => el._datasetIndex === preferredBarDatasetIndex) ||
        activeElements.find(el => el._datasetIndex === otherIndex) ||
        activeElements[0];
      let xLabel =
        pt._model && pt._model.label !== undefined && pt._model.label !== null && pt._model.label !== ""
          ? pt._model.label
          : null;
      if (
        (xLabel === null || xLabel === "") &&
        pt._chart &&
        pt._chart.data &&
        Array.isArray(pt._chart.data.labels) &&
        pt._index != null
      ) {
        xLabel = pt._chart.data.labels[pt._index];
      }
      if (xLabel === null || xLabel === undefined || xLabel === "") {
        return;
      }
      const query = this.buildIndigenousAwardsSearchQuery(xLabel);
      bus.$emit("barClicked", query);
    },
    getIndigenousDonutData(statKey) {
      if (statKey === "compliance") {
        const rows = this.indigenousStats.compliance.donutFySpend;
        const fy = this.complianceDonutSelectedFy;
        if (rows && rows.length && fy) {
          const row = rows.find((r) => r.label === fy);
          if (row) {
            const total = this.toNumber(row.totalSpend);
            const indigenous = this.toNumber(row.indigenousSpend);
            return {
              labels: ["Indigenous spend", "Other spend"],
              datasets: [
                {
                  data: [indigenous, Math.max(total - indigenous, 0)],
                  backgroundColor: ["#4EB888", "#12253a"],
                  borderColor: ["#4EB888", "#12253a"]
                }
              ]
            };
          }
        }
      }
      const donut = this.indigenousStats[statKey].donut;
      const data = donut.labels ? donut : (donut.value || donut.volume || donut);
      return {
        labels: data.labels,
        datasets: [
          {
            data: data.values,
            backgroundColor: ["#12253a", "#4EB888", "#ff1463"],
            borderColor: ["#12253a", "#4EB888", "#ff1463"]
          }
        ]
      };
    },
    onComplianceDonutFyChange() {
      this.indigenousDonutChange = Math.random() * 10000;
    },
    getHitsValue(searchData) {
      if (!searchData || !searchData.hits) {
        return 0;
      }
      if (typeof searchData.hits.value === "number") {
        return searchData.hits.value;
      }
      if (
        searchData.hits.total &&
        typeof searchData.hits.total.value === "number"
      ) {
        return searchData.hits.total.value;
      }
      if (typeof searchData.hits === "number") {
        return searchData.hits;
      }
      return 0;
    },
    toNumber(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    getBucketCount(bucket) {
      if (!bucket) {
        return 0;
      }
      if (typeof bucket.doc_count === "number") {
        return bucket.doc_count;
      }
      if (typeof bucket.count === "number") {
        return bucket.count;
      }
      if (bucket.doc_count && typeof bucket.doc_count.value === "number") {
        return bucket.doc_count.value;
      }
      return 0;
    },
    getBucketAmount(bucket) {
      if (!bucket) {
        return 0;
      }
      if (bucket.total_amount && typeof bucket.total_amount.value === "number") {
        return Math.round(bucket.total_amount.value);
      }
      if (typeof bucket.total_amount === "number") {
        return Math.round(bucket.total_amount);
      }
      if (bucket.amount && typeof bucket.amount.value === "number") {
        return Math.round(bucket.amount.value);
      }
      if (typeof bucket.amount === "number") {
        return Math.round(bucket.amount);
      }
      return 0;
    },
    getTotalAmount(searchData) {
      const aggregations =
        searchData && searchData.aggregations ? searchData.aggregations : {};
      if (aggregations.total_amount) {
        if (typeof aggregations.total_amount.value === "number") {
          return Math.round(aggregations.total_amount.value);
        }
        if (typeof aggregations.total_amount === "number") {
          return Math.round(aggregations.total_amount);
        }
      }
      if (aggregations.contracting_spend && aggregations.contracting_spend.buckets) {
        return Math.round(
          aggregations.contracting_spend.buckets.reduce(
            (sum, bucket) => sum + this.getBucketAmount(bucket),
            0
          )
        );
      }
      return Math.round(
        (searchData &&
          searchData.aggregations &&
          searchData.aggregations.total_amount &&
          searchData.aggregations.total_amount.value) ||
        0
      );
    },
    /**
     * Calendar-year bucket label for spend histograms (`contracting_spend`, etc.).
     * Keys are typically `"2024"` or a numeric year; epoch / ISO fallbacks use UTC calendar year.
     * Legacy `FY2024` / `FY24` strings are normalized to four-digit years.
     */
    getCalendarYearBucketLabel(bucket) {
      if (!bucket) return "";

      const ky = bucket.key;
      const kas = bucket.key_as_string != null ? String(bucket.key_as_string).trim() : "";

      const yearFromToken = (token) => this.calendarYearLabelToYearString(token);

      if (typeof ky === "string") {
        const fromKy = yearFromToken(ky.trim());
        if (fromKy) {
          return fromKy;
        }
      }

      if (typeof ky === "number" && Number.isFinite(ky)) {
        if (ky >= 1900 && ky <= 2100) {
          return String(Math.trunc(ky));
        }
        let ms = null;
        if (ky >= 1e11) {
          ms = ky;
        } else if (ky >= 1e9 && ky < 1e11) {
          ms = ky * 1000;
        }
        if (ms != null) {
          const d = new Date(ms);
          if (!Number.isNaN(d.getTime())) {
            return String(d.getUTCFullYear());
          }
        }
      }

      const fromKas = yearFromToken(kas);
      if (fromKas) {
        return fromKas;
      }

      const isoCandidate = kas || (typeof ky === "string" ? ky.trim() : "");
      if (isoCandidate) {
        const dIso = new Date(isoCandidate);
        if (!Number.isNaN(dIso.getTime())) {
          return String(dIso.getUTCFullYear());
        }
      }

      return "";
    },

    epochMsToCalendarYearLabel(ms) {
      const date = new Date(ms);
      if (Number.isNaN(date.getTime())) return "";
      return String(date.getUTCFullYear());
    },

    getFiscalYearSeriesByAgg(searchData, preferredAggKeys = []) {
      const aggs = searchData && searchData.aggregations ? searchData.aggregations : {};
      const aggKeys = preferredAggKeys;
      const maxBucketsInList = 20;
      let buckets = [];
      for (let i = 0; i < aggKeys.length; i += 1) {
        const key = aggKeys[i];
        if (aggs[key] && Array.isArray(aggs[key].buckets) && aggs[key].buckets.length) {
          buckets = aggs[key].buckets.slice(-maxBucketsInList);
          break;
        }
      }
      const grouped = {};
      buckets.forEach((bucket) => {
        const label = bucket["key_as_string"];
        if (!label) {
          return;
        }
        if (!grouped[label]) {
          grouped[label] = { count: 0, amount: 0 };
        }
        grouped[label].count += this.getBucketCount(bucket);
        grouped[label].amount += this.getBucketAmount(bucket);
      });
      const labels = Object.keys(grouped).sort((a, b) => this.toNumber(a) - this.toNumber(b));
      return {
        labels,
        counts: labels.map((label) => grouped[label].count),
        amounts: labels.map((label) => Math.round(grouped[label].amount))
      };
    },

    getFiscalYearSeries(searchData) {
      return this.getFiscalYearSeriesByAgg(searchData);
    },

    getGrowth(currentVal, previousVal) {
      if (!previousVal) {
        return 0;
      }
      return Number((((currentVal - previousVal) / previousVal) * 100).toFixed(1));
    },
    /**
     * YoY % change for the compliance gauge’s selected year vs the immediately previous year in `bar.labels`.
     * @param {"volume"|"value"} kind - volume = indigenous share of notices; value = indigenous share of spend.
     * @returns {number|null} null if there is no earlier year to compare.
     */
    getComplianceYoYForSelectedFy(kind) {
      const labels = this.indigenousStats.compliance.bar.labels || [];
      const amounts = this.indigenousStats.compliance.bar.amounts || [];
      const rows = this.indigenousStats.compliance.donutFySpend || [];
      const fy = this.complianceDonutSelectedFy;
      if (!labels.length || fy == null || fy === "") {
        return null;
      }
      const idx = labels.indexOf(fy);
      if (idx <= 0) {
        return null;
      }
      const prevIdx = idx - 1;
      if (kind === "value") {
        const curr = this.toNumber(amounts[idx]);
        const prev = this.toNumber(amounts[prevIdx]);
        return this.getGrowth(curr, prev);
      }
      const rCurr = rows[idx];
      const rPrev = rows[prevIdx];
      if (!rCurr || !rPrev) {
        return null;
      }
      const totC = this.toNumber(rCurr.totalAwards);
      const totP = this.toNumber(rPrev.totalAwards);
      const shareCurr =
        totC > 0 ? (this.toNumber(rCurr.indigenousAwards) / totC) * 100 : 0;
      const sharePrev =
        totP > 0 ? (this.toNumber(rPrev.indigenousAwards) / totP) * 100 : 0;
      return this.getGrowth(shareCurr, sharePrev);
    },

    setIndigenousStatsFromSearch(histogramData, indigenousHistogramData, indigenousEntityData) {
      const nextStats = JSON.parse(JSON.stringify(this.indigenousStats));
      const totalAwards = this.getHitsValue(histogramData);
      const totalSpend = this.getTotalAmount(histogramData);
      const indigenousAwardsFromHistogram = this.getHitsValue(indigenousHistogramData);
      const indigenousSpend = this.getTotalAmount(indigenousHistogramData);
      const indigenousSupplierBuckets =
        (indigenousEntityData &&
          indigenousEntityData.aggregations &&
          indigenousEntityData.aggregations.supplier &&
          indigenousEntityData.aggregations.supplier.buckets) ||
        [];
      const indigenousAwardsFromEntities = indigenousSupplierBuckets.reduce(
        (sum, bucket) => sum + (bucket.doc_count || 0),
        0
      );
      const indigenousAwards = Math.max(indigenousAwardsFromHistogram, indigenousAwardsFromEntities);

      const spendAggKeys = ["contracting_spend"];
      const totalFySeries = this.getFiscalYearSeriesByAgg(histogramData, spendAggKeys);
      console.log(totalFySeries);
      const indigenousFySeries = this.getFiscalYearSeriesByAgg(indigenousHistogramData, spendAggKeys);
      console.log(indigenousFySeries);

      const last = (arr) => (arr.length ? arr[arr.length - 1] : 0);
      const prev = (arr) => (arr.length > 1 ? arr[arr.length - 2] : 0);

      // --- Awards ---
      nextStats.awards.headline.volume = last(indigenousFySeries.counts);
      nextStats.awards.headline.value = last(indigenousFySeries.amounts);
      nextStats.awards.growth.volume = this.getGrowth(last(indigenousFySeries.counts), prev(indigenousFySeries.counts));
      nextStats.awards.growth.value = this.getGrowth(last(indigenousFySeries.amounts), prev(indigenousFySeries.amounts));
      nextStats.awards.bar = indigenousFySeries;

      // --- Compliance ---
      const targetPercent = nextStats.compliance.policy.target_percent || 4;
      const complianceLabels = totalFySeries.labels;

      const totalAmountByFy = new Map(totalFySeries.labels.map((l, i) => [l, totalFySeries.amounts[i]]));
      const indigenousAmountByFy = new Map(indigenousFySeries.labels.map((l, i) => [l, indigenousFySeries.amounts[i]]));
      const totalCountByFy = new Map(totalFySeries.labels.map((l, i) => [l, totalFySeries.counts[i]]));
      const indigenousCountByFy = new Map(indigenousFySeries.labels.map((l, i) => [l, indigenousFySeries.counts[i]]));

      const spendPercents = complianceLabels.map((label) => {
        const total = this.toNumber(totalAmountByFy.get(label));
        const indigenous = this.toNumber(indigenousAmountByFy.get(label));
        return total ? Number(((indigenous / total) * 100).toFixed(2)) : 0;
      });
      const awardSharePercents = complianceLabels.map((label) => {
        const total = this.toNumber(totalCountByFy.get(label));
        const indigenous = this.toNumber(indigenousCountByFy.get(label));
        return total ? Number(((indigenous / total) * 100).toFixed(2)) : 0;
      });

      const currentFyLabel = complianceLabels.length ? complianceLabels[complianceLabels.length - 1] : "";
      const currentFyTotalSpend = this.toNumber(totalAmountByFy.get(currentFyLabel));
      const currentFyIndigenousSpend = this.toNumber(indigenousAmountByFy.get(currentFyLabel));
      const currentFyTotalAwards = this.toNumber(totalCountByFy.get(currentFyLabel));
      const currentFyIndigenousAwards = this.toNumber(indigenousCountByFy.get(currentFyLabel));

      nextStats.compliance.policy.current_spend_percent = last(spendPercents);
      nextStats.compliance.policy.previous_spend_percent = prev(spendPercents);
      nextStats.compliance.policy.fy_total_spend = currentFyTotalSpend;
      nextStats.compliance.policy.fy_indigenous_spend = currentFyIndigenousSpend;
      nextStats.compliance.policy.fy_target_spend = Math.round((targetPercent / 100) * currentFyTotalSpend);
      nextStats.compliance.policy.awards_total = currentFyTotalAwards;
      nextStats.compliance.policy.awards_indigenous = currentFyIndigenousAwards;
      nextStats.compliance.headline.value = last(spendPercents);
      nextStats.compliance.headline.volume = currentFyIndigenousAwards;
      nextStats.compliance.growth.value = this.getGrowth(last(spendPercents), prev(spendPercents));
      nextStats.compliance.growth.volume = this.getGrowth(last(awardSharePercents), prev(awardSharePercents));

      nextStats.compliance.donutFySpend = complianceLabels.map((label) => ({
        label,
        totalSpend: this.toNumber(totalAmountByFy.get(label)),
        indigenousSpend: this.toNumber(indigenousAmountByFy.get(label)),
        totalAwards: this.toNumber(totalCountByFy.get(label)),
        indigenousAwards: this.toNumber(indigenousCountByFy.get(label))
      }));

      nextStats.compliance.bar = {
        labels: complianceLabels,
        counts: complianceLabels.map(() => targetPercent),
        amounts: spendPercents
      };

      nextStats.compliance.donut = {
        labels: ["Indigenous spend", "Other spend"],
        values: [currentFyIndigenousSpend, Math.max(currentFyTotalSpend - currentFyIndigenousSpend, 0)]
      };

      // --- Suppliers engaged (counts only; no contract amounts in chart or year rollups) ---
      const supplierIdBuckets =
        (indigenousEntityData?.aggregations?.supplier_id?.buckets) || [];

      const suppliersByFy = {};
      let totalSuppliersCount = 0;

      supplierIdBuckets.forEach((bucket) => {
        const ms = bucket?.first_contract_date?.value;
        if (!ms) return;
        const label = this.epochMsToCalendarYearLabel(ms);
        if (!label) return;
        if (!suppliersByFy[label]) suppliersByFy[label] = { count: 0 };
        suppliersByFy[label].count += 1;
        totalSuppliersCount += 1;
      });

      if (totalSuppliersCount > 0) {
        const supplierLabels = Object.keys(suppliersByFy).sort((a, b) => {
          return this.toNumber(a) - this.toNumber(b);
        });
        nextStats.suppliers.bar = {
          labels: supplierLabels,
          counts: supplierLabels.map((l) => suppliersByFy[l].count),
          amounts: []
        };
        nextStats.suppliers.headline.volume = totalSuppliersCount;
        nextStats.suppliers.headline.value = 0;
        nextStats.suppliers.growth.volume = this.getGrowth(
          last(nextStats.suppliers.bar.counts),
          prev(nextStats.suppliers.bar.counts)
        );
        nextStats.suppliers.growth.value = 0;
      } else {
        nextStats.suppliers.bar = { labels: [], counts: [], amounts: [] };
        nextStats.suppliers.headline = { volume: 0, value: 0 };
        nextStats.suppliers.growth = { volume: 0, value: 0 };
        nextStats.suppliers.donut = { labels: [], values: [] };
      }

      this.indigenousStats = nextStats;

      if (complianceLabels.length) {
        if (
          !this.complianceDonutSelectedFy ||
          complianceLabels.indexOf(this.complianceDonutSelectedFy) === -1
        ) {
          this.complianceDonutSelectedFy = complianceLabels[complianceLabels.length - 1];
        }
      } else {
        this.complianceDonutSelectedFy = null;
      }

      this.indigenousDonutChange = Math.random() * 10000;
    },

    filterColour(name) {
      return this.selectedFilter == name ? 'selected-link' : 'not-selected-link';
    },

    isEmpty(obj) {
      for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
          return false;
        }
      }

      return true;
    },

    updateSupplierList(query) {
      this.supplier_list_query.query = JSON.parse(JSON.stringify(query));
      this.supplier_list_change = Math.random() + Math.random() + Math.random();
    },

    openNetwork() {
      let routeData = this.$router.resolve({ name: 'network', query: this.$route.query });
      window.open(routeData.href, '_blank');
    },

    async compareSuppliers(comp) {
      try {
        // Use getCurrentUserProfile to get org_id
        const profile = await getCurrentUserProfile();

        // Vue 2 compatible: check for nested properties without optional chaining
        // Use org_id directly from profile.data (simpler than org_data.id)
        const orgId = profile && profile.data && profile.data.org_id
          ? profile.data.org_id
          : null;

        // Ensure both IDs are numbers for consistency
        const competitorId = parseInt(comp.supplier_id, 10);
        const userOrgId = orgId ? parseInt(orgId, 10) : null;

        // Build supplier_id array - include both competitor and user's org if orgId exists
        const supplierIds = userOrgId
          ? [competitorId, userOrgId]
          : [competitorId];

        const query = {
          supplier_id: supplierIds,
          viewIndex: 1
        };

        this.$router.push({ name: 'search', query });
      } catch (error) {
        console.error('Error in compareSuppliers:', error);
        // On error, navigate with the selected supplier only.
        const competitorId = parseInt(comp.supplier_id, 10);
        this.$router.push({ name: 'search', query: { supplier_id: [competitorId], viewIndex: 1 } });
      }
    },

    getSizeText(maxSize) {
      if (maxSize <= 1000) {
        return "< 1000"
      }
      else if (maxSize <= 5000) {
        return "< 5000"
      }
      else {
        return "5000+"
      }

    },

    reset_aggs() {
      this.expiry_aggs = [];
      this.expiring_activity = [];
      this.date_aggs = [];
      this.contracting_activity = [];
      this.publish_activity = [];
      this.annual_spend = [];
      this.category_aggs = [];
      this.supplier_aggs = [];
    },

    async loadProfile() {

      this.search = { publisher_id: this.$route.params.id, size: 1 };

      // Run all loading methods in parallel and wait for them to complete
      await Promise.all([
        this.loadTenderAggs(),
        this.loadRecentAwards(),
        this.loadOpenTenders()
      ]);

      // Only hide overlay after all methods complete
      this.overlay = false;

      this.getEntityAssessment(this.$route.params.id);

    },

    async loadBuyerIntelligence() {
      this.intelligence_loading = true;
      const publisher_id = this.$route.params.id;
      //////console.log("Loading buyer intelligence for publisher_id:", publisher_id);

      try {
        const [intelligence, competitors, opportunities] = await Promise.all([
          fetchBuyerIntelligence(publisher_id).catch((err) => {
            //////console.error("Error fetching buyer intelligence:", err);
            return null;
          }),
          fetchBuyerCompetitors(publisher_id).catch((err) => {
            //////console.error("Error fetching buyer competitors:", err);
            return null;
          }),
          fetchBuyerOpportunities(publisher_id).catch((err) => {
            //////console.error("Error fetching buyer opportunities:", err);
            return null;
          })
        ]);

        ////////console.log("Intelligence response:", intelligence);
        ////////console.log("Competitors response:", competitors);
        ////////console.log("Opportunities response:", opportunities);

        if (intelligence && intelligence.status === 'success') {
          this.buyer_intelligence = intelligence.data;
        }
        if (competitors && competitors.status === 'success') {
          this.buyer_competitors = competitors.data;
        }
        if (opportunities && opportunities.status === 'success') {
          this.buyer_opportunities = opportunities.data;
        }
      } catch (error) {
        //////console.error("Error loading buyer intelligence:", error);
        // Silently fail - intelligence is optional
      } finally {
        this.intelligence_loading = false;
      }
    },

    async loadRecentAwards() {
      let results = {};

      //let labels = [];
      results = await executeSearch(
        JSON.stringify({
          publisher_id: this.$route.params.id,
          //disposition: "Contract Notice",
          sort_field: "expiry_date",
          sort_order: "desc",
          size: 10
        })
      );

      ////////////////////////console.log("TABLE RESULTS: ", results)

      this.tenders = results.data;
      this.hit_info = results.hits;

    },

    async loadOpenTenders() {
      let results = {};

      //let labels = [];
      results = await executeSearch(
        JSON.stringify({
          publisher_id: this.$route.params.id,
          expiry_date_from: new Date().toISOString().split('T')[0],
          //expiry_date_to: new Date(new Date().getFullYear() + 100, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0],
          disposition: "Request",
          sort_field: "expiry_date",
          sort_order: "asc",
          size: 1000
        })
      );

      ////////////////////////console.log("TABLE RESULTS: ", results)

      this.open_tenders = results.data;
      this.hit_info = results.hits;
    },

    async loadTenderAggs() {
      this.loading_stats = true;

      try {
        const contractNoticeSearch = {
          ...this.search,
          disposition: "Contract Notice"
        };
        const indigenousSearch = {
          ...contractNoticeSearch,
          isindigenous: true
        };
        const [histogramData, entityData, indigenousHistogramData, indigenousEntityData] = await Promise.all([
          histogramSearch(contractNoticeSearch),
          entitySearch(contractNoticeSearch),
          histogramSearch(indigenousSearch),
          entitySearch(indigenousSearch)
        ]);

        // Handle empty responses gracefully
        this.expiry_aggs = histogramData?.aggregations?.expiring?.buckets || [];
        this.expiring_activity = histogramData?.aggregations?.expiring_activity?.buckets || [];
        this.date_aggs = histogramData?.aggregations?.contracted?.buckets || [];
        this.contracting_activity = histogramData?.aggregations?.contracting_activity?.buckets || [];
        this.publish_activity = histogramData?.aggregations?.publish_activity?.buckets || [];
        this.annual_spend = histogramData?.aggregations?.contracting_spend?.buckets || [];
        this.avg_contract = histogramData?.aggregations?.avg_contract_value?.value || 0;

        this.category_aggs = entityData?.aggregations?.major_category?.buckets || [];
        this.supplier_aggs = entityData?.aggregations?.supplier?.buckets || [];
        this.setIndigenousStatsFromSearch(histogramData, indigenousHistogramData, indigenousEntityData);

        // Set metadata as loaded
        this.metadata_loaded = true;
      } catch (error) {
        ////////console.error('Error fetching data:', error);
        // Set empty arrays on error
        this.expiry_aggs = [];
        this.expiring_activity = [];
        this.date_aggs = [];
        this.contracting_activity = [];
        this.publish_activity = [];
        this.annual_spend = [];
        this.avg_contract = 0;
        this.category_aggs = [];
        this.supplier_aggs = [];
        this.metadata_loaded = true;
      } finally {
        this.loading_stats = false;
      }
    },

    async getEntityAssessment(id) {

      this.assessment_loading = true;

      entityAssessment(id).then(data => {
        this.assessment = data.data;
        this.assessment_loaded = true;
      });

    },

    async getSupplierStats(id) {
      if (this.supplier_stats_loaded == false) {
        try {
          const data = await supplierStats(id);
          this.supplier_stats = data.data.supplier_stats;
          this.supplier_stats_loaded = true;
        } catch (error) {
          ////////console.error("Error fetching supplier stats:", error);
        }
      }
      else {
        return true;
      }

    },

    disableIcon(url) {
      if (!url) {
        return true;
      } else {
        return false;
      }
    },

    toggle() {
      this.watching = !this.watching;
      this.is_saved();
    },

    is_saved() {
      ////////////////////////console.log("NOTIFY STATUS: " + this.current_search.notify)
      return this.watching;
    },

    async openInsightsModal() {
      this.show_insights_modal = true;
      // Load intelligence data when modal is opened
      if (!this.buyer_intelligence && !this.buyer_competitors && !this.buyer_opportunities && !this.intelligence_loading) {
        await this.loadBuyerIntelligence();
      }
    }
  }
};
</script>

<style>
.selected-link {
  color: #ff4081 !important;
}

.not-selected-link {
  color: #12253a !important;
}

.chart {
  border-color: #424242 !important;
}

.headingUnderline {
  border-color: aqua !important;
}

/* Indigenous Procurement tab — first row: 2fr 2fr 1fr (md and up) */
@media (max-width: 959px) {
  .indigenous-prop-panel-card {
    max-height: min(85vh, 36rem);
    overflow: hidden;
  }
}

@media (min-width: 960px) {
  .indigenous-procurement-row-top.row {
    display: grid !important;
    /* minmax(0, …) lets charts shrink so all 3 columns stay on one row */
    grid-template-columns: minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1fr);
    align-items: stretch;
    margin-left: 0 !important;
    margin-right: 0 !important;
    flex-wrap: nowrap !important;
    width: 100%;
  }

  .indigenous-procurement-row-top.row>.col {
    max-width: none !important;
    flex: 0 1 auto !important;
    width: auto !important;
    min-width: 0 !important;
    /* Let row height follow chart columns; avoid min-content height from long lists */
    min-height: 0 !important;
  }

  .indigenous-procurement-row-top.row > .indigenous-prop-col {
    /* Take this cell out of row-height calculation: the card is absolutely
       positioned, so the row is sized purely by the chart columns. */
    position: relative;
    overflow: hidden;
  }

  .indigenous-procurement-row-top.row > .indigenous-prop-col > .indigenous-prop-panel-card {
    position: absolute;
    top: 12px; /* matches pt-3 on the col */
    right: 0;
    bottom: 12px; /* matches mb-3 on the card */
    left: 4px; /* matches pl-md-1 on the col */
    margin: 0 !important;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
